import { useState } from "react";
import { Send } from "lucide-react";

import { api, ApiError } from "../../api/client";

/** "Resend" for a colleague who was asked for feedback and hasn't replied.
 *  The server checks the request was sent, isn't answered and that the
 *  caller is the review's manager or HR. */
export default function ResendColleagueButton({ feedbackId, name }: { feedbackId: number; name: string }) {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<{ ok: boolean; text: string } | null>(null);
  return (
    <span className="inline-flex flex-col items-end">
      <button
        type="button"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            const r = await api.post<{ sent: boolean; message: string }>(`/api/reviews/colleague-feedback/${feedbackId}/resend`);
            setNote({ ok: r.sent, text: r.message });
          } catch (e) {
            setNote({ ok: false, text: e instanceof ApiError ? e.message : "Couldn't resend. Try again." });
          }
          setBusy(false);
        }}
        title={`Send ${name} the feedback request again`}
        className="inline-flex items-center gap-1 rounded border border-pme-blue/30 px-1.5 py-0.5 text-[10px] font-medium text-pme-blue hover:bg-pme-sky disabled:opacity-50"
      >
        <Send size={10} aria-hidden />
        {busy ? "Sending…" : "Resend"}
      </button>
      {note && (
        <span className={`mt-0.5 max-w-[220px] text-right text-[10px] ${note.ok ? "text-green-700" : "text-amber-700"}`} aria-live="polite">
          {note.text}
        </span>
      )}
    </span>
  );
}
